export default __webpack_public_path__ + "static/media/DSC_7981.4ad0763e.jpg";